import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 5. 创建并挂载根实例
const app2 = window.cloudbase.init({
 env:"cloud1-0gl88yx1944d9f7d",
    clientId:'AOJ8yAAB0gtjEqkf73E'
  });
 

const app = createApp(App);
app.config.globalProperties.$cloudbase =app2;
app.config.globalProperties.$auth =app2.auth();
//确保 _use_ 路由实例使
//整个应用支持路由。
app.use(router);
app.mount('#app');

